import * as z from 'zod'

// zod 4 dropped zod 3's "Required" for a missing field in favour of
// "Invalid input: expected string, received undefined", which forms without
// their own message would show to users. Restore it globally; messages set on
// a schema still take precedence. Import zod from here, not 'zod', so this
// runs before any schema is parsed.
z.config({
  customError: (issue) =>
    issue.code === 'invalid_type' && issue.input === undefined
      ? 'Required'
      : undefined
})

export * from 'zod'
